export default __webpack_public_path__ + "static/media/Paqueteria_Local_Quiken.e6aa7d34.png";